module.exports = __webpack_public_path__ + "img/680647063.0a2bf7ae.jpg";